import React from 'react';
import { Container, Row, Col } from "reactstrap";

import sercoLogo from "../../static/images/serco_v2_logo_rgb.png";
import psiLogo from "../../static/images/psi-logo-2.png";
import gcuLogo from "../../static/images/gcu_logo.jpg";
import ctLogo from "../../static/images/logo-horizontal-flat.png";
import gaiaLogo from "../../static/images/gaia-logo.png";

import SectionTitleRow from "../shared/SectionTitleRow";
import Divider from "../shared/Divider";

const PreviousClients = () => {
  return (
    <Container>
      <a className="ccc-anchor" id="howICanHelpYou" />

      <Divider />
      <SectionTitleRow>Some previous clients</SectionTitleRow>
      <Row className="align-items-centre">
        <Col md={6} lg>
          <img src={sercoLogo} className="w-100 p-4" alt="Serco logo" />
        </Col>
        <Col md={6} lg>
          <img src={psiLogo} className="w-100 p-4" alt="PSI logo" />
        </Col>
        <Col md={6} lg>
          <img src={gcuLogo} className="w-100 p-4" alt="Glasgow Caledonian University logo" />
        </Col>
        <Col md={6} lg>
          <img src={ctLogo} className="w-100 p-4" alt="Charlbury Technology logo" />
        </Col>
        <Col md={6} lg>
          <img src={gaiaLogo} className="w-100 p-4" alt="Gaia Skincare logo" />
        </Col>
      </Row>
      <Divider />
    </Container>
  )
}

export default PreviousClients;

